import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CANDIDATE, CANDIDATE_DETAILS_BY_PARAM, CANDIDATE_ITSKILLS_PARAM, CANDIDATE_SKILLS, PUBLIC_SKILLS } from "../../../common/URLs";


export const fetchITskills = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_DETAILS_BY_PARAM}?${CANDIDATE_ITSKILLS_PARAM}`; // Proxy path
  try {
    const token = await fetchToken() 
    // console.log("token", token)
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchCoreSkills = async () => {
  const url = `${BASE_URL}/${CANDIDATE}/${PUBLIC_SKILLS}`; // Proxy path
  try {
    const token = await fetchToken() 
    // console.log("token", token)
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response in api", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addITskill = async (newITskill) => {
  const url = `${BASE_URL}/${CANDIDATE}/${CANDIDATE_SKILLS}`; // Proxy path
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newITskill),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const deleteITskill = async (uuid) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_SKILLS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job title: " + error.message);
  }
};

export const updateITskill = async (uuid, ITskillData) => {
  try {
    const token = await fetchToken()
    const response = await fetch(`${BASE_URL}/${CANDIDATE}/${CANDIDATE_SKILLS}/${uuid}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(ITskillData),
    });

    // console.log("jobtitle", jobTitleData, id, status);

    if (!response.ok) {
      throw new Error("Error updating job title: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job title: " + error.message);
  }
};
